module.exports = __webpack_public_path__ + "img/oracle.d485d0ec.jpg";